import React from "react";

const Bottom = () => {
  return (
    <div className="bottom">
      <div className="container d-flex justify-content-between align-items-center pt-3">
        <p>
          Copyright © 2022. All Rights Reserved By <span>CM-Repair</span>
        </p>
        <div className="d-flex justify-content-center align-items-center gap-5">
          <h6 className="bottom-border">Get Support</h6>
          <h6 className="bottom-border">Our Plugins</h6>
          <h6 className="theme">Our Themes</h6>
        </div>
      </div>
    </div>
  );
};

export default Bottom;
